import { ApplicationUser } from '@/types/application-user';
import { isUserOrganisationAdmin } from '../is-user-organisation-admin';
import { isUserPlatformAdmin } from '../is-user-platform-admin';

export const canActiveUserEditUser = (
  activeUser: ApplicationUser,
  user: ApplicationUser,
): boolean => {
  // Platform Admin can edit all accounts
  if (isUserPlatformAdmin(activeUser)) {
    return true;
  }

  // Org Admin can not edit Platform Admin
  if (isUserOrganisationAdmin(activeUser)) {
    return isUserPlatformAdmin(user) === false;
  }

  return false;
};
